export default __webpack_public_path__ + "media/color/bpt-09532cf4.svg";